import { Box } from '@mui/material';
import React from 'react';

import { Label } from '../Label';
import { WsTagsList, ChipsType } from '../WsTagsList';
export interface IFilterList {
  tag: string;
  id: string;
}

interface WsFilterTagsProps {
  filtersList: IFilterList[];
  onDelete?: (chip: string) => void;
  label?: string;
  isKeyNotReq?: boolean;
}

const WsFilterTags = ({
  filtersList,
  onDelete,
  label = 'Results generated for:',
  isKeyNotReq = true,
}: WsFilterTagsProps) => {
  return filtersList.length > 0 ? (
    <Box my={2}>
      <Label sx={{ fontWeight: 'bold' }}>{label}</Label>
      <WsTagsList
        chipArray={filtersList.map((filter) => filter.tag)}
        count={100}
        type={ChipsType.PRIMARY}
        allowDelete={true}
        onDelete={onDelete}
        isKeyNotReq={isKeyNotReq}
      />
    </Box>
  ) : (
    <></>
  );
};

export default WsFilterTags;
